import * as monaco from "monaco-editor";
import { formatVariables, getProgramAndPanel } from "./utils";
export function getSolLanguageSuggestions(model, position, getVariables, variables, job) {
    var textUntilPositionUpdate = model.getValueInRange({
        startLineNumber: position.lineNumber,
        startColumn: 1,
        endLineNumber: position.lineNumber,
        endColumn: position.column,
    });
    var matchupdate = textUntilPositionUpdate.match(/update\s*[^"]*\s*"[^"]*"\s*/);
    var matchread = textUntilPositionUpdate.match(/readdb\s*[^"]*\s*"[^"]*"\s*/);
    var suggestions = [];
    if (matchupdate || matchread) {
        const { program, panel } = getProgramAndPanel(matchupdate ? matchupdate : matchread);
        const wkp = job.workspaces[0];
        getVariables({ wkp, program, panel });
        return addSuggestionsServer(suggestions, variables, model, position, matchupdate ? "inputs" : "outputs");
    }
    addSuggestions(suggestions, getKeywords());
    addSuggestions(suggestions, getFunctionsKeywords());
    addSuggestions(suggestions, getDatesKeywords());
    addSuggestions(suggestions, getDateNapeosKeywords());
    addSuggestions(suggestions, getListKeywords());
    addSuggestions(suggestions, getTypeKeywords());
    addSuggestions(suggestions, getBooleanKeywords());
    suggestions.sort();
    var proposals = [
        {
            label: "define-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: ["define procedure ${1:condition}", "\t$0", "end define"].join("\n"),
            },
            documentation: "Define Statement",
        },
        {
            label: "execute-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "execute procedure ${1:procedure_name}",
            },
            documentation: "Execute a SOL procedure",
        },
        {
            label: "set-var",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "set ${1:condition} to $0",
            },
        },
        {
            label: "increment-by",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "increment ${1:varibale} by $0",
            },
            documentation: "increment a datum value",
        },
        {
            label: "decrement-by",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "decrement ${1:varibale} by $0",
            },
            documentation: "decrement a datum value",
        },
        {
            label: "if-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: ["if ${1:condition} then", "\t$0", "end if"].join("\n"),
            },
            documentation: "If Statement",
        },
        {
            label: "if-else-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: [
                    "if ${1:condition} then",
                    "\t$0",
                    "otherwise",
                    "\t",
                    "end if",
                ].join("\n"),
            },
            documentation: "If-else Statement",
        },
        {
            label: "repeat-for-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: [
                    "repeat for ${1:variable} from ${2:value} to ${3:valueN}",
                    "\t$0",
                    "end repeat",
                ].join("\n"),
            },
            documentation: "Looping for a predefined number of times",
        },
        {
            label: "repeat-while-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: ["repeat while ${1:condition}", "\t$0", "end repeat"].join("\n"),
            },
            documentation: "Looping while an expression is true",
        },
        {
            label: "repeat-foreach-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: [
                    "repeat for each ${1:foreach} in ${2:list}",
                    "\t$0",
                    "end repeat",
                ].join("\n"),
            },
            documentation: "Looping over list elements",
        },
        {
            label: "write-logger-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "write logger ${1:serverity} ${2:message}",
            },
            documentation: "Send a message with a severity level to the focussuite Evelog. The possible severity levels are: admin, info warning or error",
        },
        {
            label: "write-output-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: 'write output ${2:""}',
            },
            documentation: "Send the value of the expression to the output of the procedure",
        },
        {
            label: "schedule-procedure-date-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "schedule ${1:procedure_name} for date ${2:abs_date}",
            },
            documentation: "Allows scheduling a procedure",
        },
        {
            label: "schedule-procedure-event-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "schedule ${1:procedure_name} for event ${2:event}",
            },
            documentation: "Allows scheduling a procedure",
        },
        {
            label: "reschedule-procedure-date-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "reschedule ${1:procedure_name} for date ${2:abs_date}",
            },
            documentation: "Reschedules the procedure being executed and finishes its execution",
        },
        {
            label: "reschedule-procedure-event-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "reschedule ${1:procedure_name} for event ${2:event}",
            },
            documentation: "Reschedules the procedure being executed and finishes its execution",
        },
        {
            label: "update-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: [
                    "update ${1:program_name}",
                    "\t& inputs are",
                    "\t& set ${2:input} to ${3:value}",
                ].join("\n"),
            },
            documentation: "Writes values to a structured input file that can be read by computation programs",
        },
        {
            label: "readdb-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: [
                    "readdb ${1:program_name}",
                    "\t& outputs are",
                    "\t& set ${2:out} to ${3:value}",
                ].join("\n"),
            },
            documentation: "Reads values from a structured input file that can be read by computation programs",
        },
        {
            label: "convert-variable-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "convert ${1:variable} from ${2:type1} to ${3:type2}",
            },
            documentation: "Converts values between different representations. The possible conversions are: date to mjd2000, " +
                "mjd2000 to date and any combination of binary, octal, decimal, hexadecimal",
        },
        {
            label: "format-float-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "format float ${1:variable} to ${2:number_decimals}",
            },
            documentation: "Rounds a floating-point value to a number of decimals",
        },
        {
            label: "sleep-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "sleep ${1:integer}",
            },
            documentation: "Sleep number of seconds",
        },
        {
            label: "replace-statement",
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: {
                value: "sreplace ${1:integer1} ${2:integer2} from ${3:variable} to ${4:expression}",
            },
            documentation: "Characters indexes of variable to be replaced by the substring expression. " +
                "Note: if expression is empty the SREPLACE can be used to delete characters in the variable",
        },
        {
            label: "switch-case-statement",
            kind: monaco.languages.CompletionItemKind.Keyword,
            insertText: {
                value: [
                    "switch ${1:value}",
                    "\tcase ${2:condition}",
                    "\t\t ${3:code}",
                    "\tcase ${4:condition}",
                    "\t\t ${5:code}",
                    "\tdefault",
                    "\t\t ${6:code}",
                    "end switch",
                ].join("\n\n"),
            },
            documentation: "switch-case statement",
        },
    ];
    return proposals.concat(suggestions);
}
function addSuggestions(suggestions, tokens) {
    for (let token in tokens) {
        suggestions.push({
            label: tokens[token],
            kind: monaco.languages.CompletionItemKind.Text,
            insertText: tokens[token],
        });
    }
    return suggestions;
}
function addSuggestionsServer(suggestions, tokens, model, position, inout) {
    let line = 1;
    let wordNextLine = model.getLineContent(position.lineNumber + line);
    let matchNext = wordNextLine.match(/s*[inputs|outputs]\s*are\s*/);
    if (matchNext) {
        line++;
        let append = [];
        let indent = wordNextLine.substring(0, wordNextLine.search(/\S/));
        while (matchNext) {
            append.push(wordNextLine);
            wordNextLine = model.getLineContent(position.lineNumber + line);
            matchNext = wordNextLine.match(/s*set\s*[^"]*\s*to\s*/);
            line++;
        }
        line--;
        let appendLine = new monaco.Range(position.lineNumber + 1, 1, position.lineNumber + line, 1);
        for (let token in tokens) {
            let suggests = append.slice();
            suggests.push(indent + checkInOut(inout, tokens[token]));
            suggests.push("");
            suggestions.push({
                label: tokens[token].id,
                kind: monaco.languages.CompletionItemKind.Function,
                insertText: "",
                additionalTextEdits: [
                    {
                        range: appendLine,
                        text: suggests.join("\n"),
                    },
                ],
            });
        }
    }
    else {
        for (let token in tokens) {
            suggestions.push({
                label: tokens[token].id,
                kind: monaco.languages.CompletionItemKind.Function,
                insertText: {
                    value: [
                        "",
                        "\t& " + inout + " are",
                        "\t" + checkInOut(inout, tokens[token]),
                    ].join("\n"),
                },
            });
        }
    }
    return suggestions;
}
const checkInOut = (inout, token) => {
    return inout === "outputs"
        ? "& set localVar to " + formatVariables(token.id)
        : "& set " + token.id + " to " + formatVariables(token.name);
};
export function getKeywords() {
    return [
        "debug",
        "abort",
        "admin",
        "alarm",
        "archive",
        "archiveid",
        "archiveflag",
        "are",
        "backup",
        "break",
        "by",
        "case",
        "continue",
        "convert",
        "decrement",
        "default",
        "define",
        "each",
        "end",
        "execute",
        "fail",
        "file",
        "finish",
        "for",
        "format",
        "from",
        "float",
        "high",
        "highest",
        "if",
        "in",
        "info",
        "increment",
        "inputs",
        "ladd",
        "logger",
        "low",
        "lremove",
        "lset",
        "medium",
        "otherwise",
        "output",
        "outputs",
        "readdb",
        "repeat",
        "reschedule",
        "restore",
        "pause",
        "print",
        "procedure",
        "processmode",
        "set",
        "schedule",
        "shared",
        "slength",
        "sget",
        "sleep",
        "sreplace",
        "step",
        "switch",
        "then",
        "to",
        "update",
        "warning",
        "while",
        "workspace",
        "write",
    ];
}
export function getFunctionsKeywords() {
    return [
        "sin",
        "cos",
        "tan",
        "asin",
        "acos",
        "atan",
        "sinh",
        "cosh",
        "tanh",
        "sqrt",
        "log10",
        "log",
        "abs",
        "int",
        "round",
        "flor",
        "ceil",
        "boolean",
        "deg2rad",
        "rad2deg",
        "deg2hhmm",
        "sec2hhmms",
        "stringlength",
        "min",
        "max",
        "module",
        "real",
        "truncate",
        "atan2",
        "repeatchars",
        "sum",
    ];
}
export function getDatesKeywords() {
    return [
        "seconds",
        "minutes",
        "hours",
        "days",
        "weeks",
        "year",
        "now",
        "today",
        "monthofyear",
        "weekofyear",
        "dayofweek",
        "dayofyear",
        "hourofday",
        "minuteofhour",
        "secondofminute",
        "hhmm2deg",
        "hhmmss2sec",
        "hhmmss2days",
        "timeofday",
    ];
}
export function getDateNapeosKeywords() {
    return [
        "createdate",
        "getdatequal",
        "getdatevalue",
        "createinterval",
        "getintervqual1",
        "getintervqual2",
        "getintervdate1",
        "getintervdate2",
    ];
}
export function getListKeywords() {
    return ["lget", "llength"];
}
export function getTypeKeywords() {
    return ["date", "mjd2000", "decimal", "octal", "hexadecimal", "binary"];
}
export function getBooleanKeywords() {
    return ["true", "false"];
}
//# sourceMappingURL=solLanguageSuggestions.js.map